import React from 'react';
import { Box, Container, Divider, Flex, HStack, Link, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { MoonStarIcon } from 'lucide-react';
import { brand, whatsappHref } from '../data/brand';
const navLinks = [{
  label: 'Servicios',
  href: '#servicios'
}, {
  label: '¿Por qué consultarnos?',
  href: '#por-que'
}, {
  label: 'Acerca de nosotros',
  href: '#nosotros'
}, {
  label: 'Galería',
  href: '#galeria'
}, {
  label: 'Experiencias',
  href: '#experiencias'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <Box as="footer" bg="plum.950" color="plum.100" pt={{
    base: 12,
    md: 16
  }} pb={{
    base: 10,
    md: 12
  }} data-id="element-85" data-mp="3lelzw41qqjmm">
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} data-id="element-86" data-mp="3qcxawi3rv06f">
        <SimpleGrid columns={{
        base: 1,
        md: 3
      }} spacing={{
        base: 8,
        md: 10
      }} data-id="element-87" data-mp="3qblzbw434o4r">
          <VStack align="flex-start" spacing={4} data-id="element-88" data-mp="29xlz0k1buwgz">
            <HStack spacing={3} data-id="element-89" data-mp="2ey09s9ubckip">
              <Flex align="center" justify="center" w="2.25rem" h="2.25rem" borderRadius="full" border="1px solid" borderColor="gold.400" color="gold.300" data-id="element-90" data-mp="2ezbf4e3eq0bx">
                <MoonStarIcon size={18} aria-hidden="true" data-id="element-91" data-mp="3v8rko4g8tq2i" />
              </Flex>
              <Text fontFamily="heading" fontSize="lg" fontWeight={600} color="cream.50" data-id="element-92" data-mp="3q8dk17gz1iei">
                {brand.name}
              </Text>
            </HStack>
            <Text fontSize="sm" color="plum.200" data-id="element-93" data-mp="80nrednpyga8">
              Orientación espiritual y prácticas esotéricas tradicionales, con atención personalizada
              desde Miami, Florida.
            </Text>
          </VStack>

          <VStack align="flex-start" spacing={3} data-id="element-94" data-mp="cu0cidt6w4y8">
            <Text fontSize="0.68rem" letterSpacing="0.18em" textTransform="uppercase" color="gold.300" data-id="element-95" data-mp="cuiku8t4m9mi">
              Contacto
            </Text>
            <Link href={brand.phoneHref} fontSize="sm" _hover={{
            color: 'gold.200'
          }} data-id="element-96" data-mp="mptrs4yamcjp">
              Teléfono: {brand.phone}
            </Link>
            <Link href={whatsappHref()} isExternal fontSize="sm" _hover={{
            color: 'gold.200'
          }} data-id="element-97" data-mp="yteimcuyu4qm">
              WhatsApp: {brand.whatsapp}
            </Link>
            <Link href={brand.emailHref} fontSize="sm" wordBreak="break-word" _hover={{
            color: 'gold.200'
          }} data-id="element-98" data-mp="18ksl8ti7rknz">
              {brand.email}
            </Link>
            <Text fontSize="sm" data-id="element-99" data-mp="1hkffmvcizq7j">{brand.location}</Text>
          </VStack>

          <VStack align="flex-start" spacing={3} data-id="element-100" data-mp="1hmidu2nu0pnc">
            <Text fontSize="0.68rem" letterSpacing="0.18em" textTransform="uppercase" color="gold.300" data-id="element-101" data-mp="1mktq0k1lnc8q">
              Navegación
            </Text>
            {navLinks.map(link => <Link key={link.href} href={link.href} fontSize="sm" _hover={{
            color: 'gold.200'
          }} data-id="element-102" data-mp="3ta8avl5p53c1">
                {link.label}
              </Link>)}
          </VStack>
        </SimpleGrid>

        <Divider borderColor="whiteAlpha.200" my={{
        base: 8,
        md: 10
      }} data-id="element-103" data-mp="25of2ufazseml" />

        <Stack direction={{
        base: 'column',
        md: 'row'
      }} justify="space-between" align={{
        base: 'flex-start',
        md: 'center'
      }} spacing={4} data-id="element-104" data-mp="25mamuyztjp5y">
          <Text fontSize="xs" color="plum.300" data-id="element-105" data-mp="1wpjuoxoe0ugn">
            © {new Date().getFullYear()} {brand.name}. Todos los derechos reservados.
          </Text>
          <HStack spacing={6} data-id="element-106" data-mp="2pbuui6466rce">
            <Link href="#informacion-importante" fontSize="xs" color="plum.200" _hover={{
            color: 'gold.200'
          }} data-id="element-107" data-mp="2pdpe9h3pgdew">
              Términos y condiciones
            </Link>
            <Link href="#informacion-importante" fontSize="xs" color="plum.200" _hover={{
            color: 'gold.200'
          }} data-id="element-108" data-mp="2feq6e0qrklsy">
              Política de privacidad
            </Link>
          </HStack>
        </Stack>
      </Container>
    </Box>;
}